import { localStorageSet } from '../utils/localStorage';

/**
 * Main reducer for global AppStore using "Redux styled" actions
 * @function AppReducer
 * @param {object} state - current/default state
 * @param {string} action.type - unique name of the action
 * @param {*} [action.payload] - optional data object or the function to get data object
 */
const AppReducer = (state, action) => {
  switch (action.type) {
    case 'SET_CURRENT_USER':
      return {
        ...state,
        currentUser: action?.currentUser || action?.payload,
      };
    case 'SET_DARK_MODE': {
      const darkMode = action?.darkMode ?? action?.payload;
      localStorageSet('darkMode', darkMode);
      return {
        ...state,
        darkMode,
      };
    }
    case 'SET_ERROR':
      return {
        ...state,
        error: action.payload,
      };
    case 'SET_DISP_MARKET':
      return {
        ...state,
        isDispMarket: action.isDispMarket
      };
    case 'SELECTED_ODD':
      return {
        ...state,
        betState: 1,
        selectedOdd: action.odd
      };
    case 'CLEAR_BET_SLIP':
      return {
        ...state,
        betState: 0,
        selectedOdd: action.odd
      };
    case 'PLACE_BET':
      return {
        ...state,
        betState: 2,
        transaction: action.hash
      };
    case 'CANCEL_BET':
      return {
        ...state,
        transaction: action.hash
      };
    case 'SET_SOCCER_MODE':
      localStorageSet('soccerMode', action.soccerMode);
      return {
        ...state,
        soccerMode: action.soccerMode
      };
    case 'SET_LAYBET_SLIP_STYLE':
      localStorageSet('layBetSlipStyle', action.layBetSlipStyle);
      return {
        ...state,
        layBetSlipStyle: action.layBetSlipStyle
      };
    case 'SET_ODDS_STYLE':
      localStorageSet('oddsStyle', action.oddsStyle);
      return {
        ...state,
        oddsStyle: action.oddsStyle
      };
    case "SET_URL":
      console.log("seturl ran");
      return {
        ...state,
        urlAddOn: action.paramStr,
        urlChangeSignal: action.signal
      };
    case "RETRIEVE_HISTORY":
      console.log("bet history retrieved");
      return {
        ...state,
        betHistory: action.payload
      };
    case "justbet":
      return {
        ...state,
        odds: action.odds,
        stake: action.stake,
        justbet: "justbet" + action.odds + action.stake
      }
    default:
      return state;
  }
};

export default AppReducer;
